import { Component, Input, ViewChild } from '@angular/core';
import { CalendarComponent } from '../calendar/calendar.component';
import { AbstractFormControl } from '../abstract-form-control';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'md-multi-datepicker',
  templateUrl: './multi-datepicker.component.html',
  styleUrls: ['./multi-datepicker.component.scss']
})
export class MultiDatepickerComponent extends AbstractFormControl {

  @Input() formModel!: FormControl;

  @ViewChild(CalendarComponent, { static: true }) calendar!: CalendarComponent; 
  
  constructor() { 
    super();
  }

  removeDate(index: number): void {
    const dates: Date[] = this.formModel.value;
    dates.splice(index, 1);
    
    this.formModel.markAsDirty();
    if (dates.length) {
      this.formModel.setValue(dates);
    } else {
      this.formModel.setValue(null);
    }
  }

}
